import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  ViewChild
} from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { MatDialog } from "@angular/material/dialog";
import { MatTabGroup } from "@angular/material/tabs";
import { TranslateService } from "@ngx-translate/core";
import { map, take } from "rxjs/operators";
import { AdvVoicemailboxWithExt } from "../admin-voicemail-types";
import { ModalMaterialComponent } from "../../../shared/components/modal/modal-material.component";
import { Subscription } from "rxjs";

@Component({
  selector: "onsip-admin-voicemail-shelf-container",
  templateUrl: "./admin-voicemail-shelf-container.component.html",
  styleUrls: ["./admin-voicemail-shelf-container.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminVoicemailShelfComponent implements OnDestroy {
  @ViewChild(MatTabGroup) matTabGroup!: MatTabGroup;
  @Input() voicemail!: AdvVoicemailboxWithExt;
  private prevSelectedIndex = 0;
  mode: "view" | "edit" = "view";

  lessThanMediumBreakpoint = this.breakpointObserver
    .observe([Breakpoints.Small, Breakpoints.XSmall])
    .pipe(map(result => result.matches));

  private unsubscriber = new Subscription();

  constructor(
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }

  // just copied this from admin-portal-tab - maybe we can make this a directive?
  onSelectedIndexChange(event: number) {
    if (this.mode === "edit" && this.matTabGroup.selectedIndex !== this.prevSelectedIndex) {
      this.matTabGroup.selectedIndex = this.prevSelectedIndex;
      const modal = this.dialog.open(ModalMaterialComponent, {
        panelClass: ["mat-typography", "onsip-dialog-universal-style"],
        data: {
          title: this.translate.instant("ONSIP_I18N.CANCEL_EDITS"),
          message: this.translate.instant("ONSIP_I18N.ANY_CHANGES_YOU_HAVE_MADE_WILL_NOT_BE_SAVED"),
          primaryBtnText: this.translate.instant("ONSIP_I18N.OK"),
          secondaryBtnText: this.translate.instant("ONSIP_I18N.KEEP_EDITING"),
          primaryBtnFlat: true
        }
      });

      this.unsubscriber.add(
        modal
          .afterClosed()
          .pipe(take(1))
          .subscribe(retObj => {
            if (retObj && retObj.doPrimaryAction) {
              this.mode = "view";
              this.prevSelectedIndex = this.matTabGroup.selectedIndex || 0;
              this.matTabGroup.selectedIndex = event;
              this.cdRef.markForCheck();
            } else if (retObj && !retObj.doPrimaryAction) {
              this.mode = "edit"; // pressed "keep editing"
            }
          })
      );
    } else {
      this.mode = "view";
      this.prevSelectedIndex = this.matTabGroup.selectedIndex || 0;
      this.matTabGroup.selectedIndex = event;
    }
  }
}
